/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Permission Rule Action
 */
export enum PermissionRuleAction {
    U_READ = 'uRead',
    U_CREATE = 'uCreate',
    U_UPDATE = 'uUpdate',
    U_DELETE = 'uDelete',
    U_EXECUTE = 'uExecute',
    UNKNOWN = 'unknown',
}